var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sex-icon"},[(_vm.sex == '1')?_c('img',{attrs:{"src":require("@/assets/crm/icon/icon-male.png"),"alt":""}}):_c('img',{attrs:{"src":require("@/assets/crm/icon/icon-female.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }